// extracted by mini-css-extract-plugin
export default {"header":"src-client-modal-modals-confirmationModal-___styles__header___P0cGg","confirmationModal":"src-client-modal-modals-confirmationModal-___styles__confirmationModal___JCUvL"};